import { api } from "../../http";

export const getPostById = async (id: string): Promise<any> => {
  const response = api.get(`/profiles/post/${id}`).then(({ data }) => data);
  return response;
};
